module.exports = __webpack_public_path__ + "static/signature180-6d8ed7902cec6c35d943303b23c4ce7e.png";